import { FormattedMessage } from 'react-intl'
import { InputAdornment } from '@mui/material'
import { MenuItem, Typography, SelectField } from '@carto/meridian-ds/components'
import { Operations, OperationType } from 'features/analysis/types'
import FunctionsAltIcon from 'assets/icons/functions_alt.svg?react'

function AggregationFunctionSelector({
  operator,
  onChange,
  isOptional = false
}: {
  operator: OperationType
  onChange: (operator: OperationType) => void
  isOptional?: boolean
}) {
  const operations = Object.keys(Operations)

  return (
    <SelectField
      displayEmpty
      label={<FormattedMessage id="analysis.intersect.aggregationOp" />}
      labelId="geom-field"
      value={operator || ''}
      onChange={(e) => onChange(e.target.value as OperationType)}
      startAdornment={
        <InputAdornment position="start">
          <FunctionsAltIcon />
        </InputAdornment>
      }
      renderValue={(selected) => {
        if (!selected) {
          return (
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage id="analysis.centroid.selectOp" />
            </Typography>
          )
        }
        const operation = selected as OperationType
        return (
          <MenuItem key={operation} value={operation}>
            {operation?.toUpperCase()}
          </MenuItem>
        )
      }}
    >
      {isOptional && operator ? (
        <MenuItem value="">
          <Typography variant="body2" color="textSecondary">
            <FormattedMessage id="analysis.centroid.operatorNone" />
          </Typography>
        </MenuItem>
      ) : null}
      {operations.map((operation) => (
        <MenuItem key={operation} value={operation}>
          {operation.toUpperCase()}
        </MenuItem>
      ))}
    </SelectField>
  )
}

export default AggregationFunctionSelector
